module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2021/wigilia/thumbs/46-78ca88f9b40590aa3f19ea41f5e0e397.webp";